var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseLogistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.739 18.7888H28.9167V12.4412L25.3035 6.67944L21.739 12.4412V18.7888ZM18.8093 13.5154H0.449951V49.99H14.5613V31.1912L18.8093 24.3552V13.5154ZM23.8386 3.50562V-0.0100098H5.47925V4.33569L1.62183 10.5857H19.4441L23.8386 3.50562ZM35.2644 27.5779L32.4812 32.0212V49.99H38.0476V32.0212L35.2644 27.5779ZM17.491 33.0466H29.5515V49.99H17.491V33.0466ZM33.7996 21.7185H21.739V25.1853L18.6628 30.1169H30.2351L33.7996 24.3552V21.7185Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.449951 49.99)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseLogistics);
export default __webpack_public_path__ + "static/media/chooseLogistics.830a97f05f40933441006bfc243a4db6.svg";
export { ForwardRef as ReactComponent };